let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cTYjq")).then(() => parcelRequire('3MvBZ'));